import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_9ec7afdd-8040-4034-8218-64e5a74fdccb/artifacts/8npbah8c_COI%20-%20Small%20Logo.png";

export const Header = () => {
  const loc = useLocation();
  const linkCls = (path) =>
    `font-mono-tight text-xs uppercase tracking-[0.2em] px-3 py-2 border-2 border-slate-900 brutal-hover brutal-shadow ${
      loc.pathname === path ? "bg-slate-900 text-white" : "bg-white text-slate-900"
    }`;

  return (
    <header
      className="border-b-2 border-slate-900 bg-white sticky top-0 z-40"
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-8 py-4">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="home-link"
        >
          <div className="w-12 h-12 bg-white border-2 border-slate-900 flex items-center justify-center brutal-shadow overflow-hidden">
            <img src={LOGO_URL} alt="Clonmel On Ice" className="w-full h-full object-contain" />
          </div>
          <div>
            <div className="font-display text-lg leading-none uppercase">
              Clonmel On Ice 2026
            </div>
            <div className="font-mono-tight text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-1">
              Rink Booking · 2026/27
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-3">
          <Link to="/" className={linkCls("/")} data-testid="nav-book">
            Book
          </Link>
          <Link to="/lookup" className={linkCls("/lookup")} data-testid="nav-lookup">
            Lookup
          </Link>
          <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">
            Admin
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
